var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEtcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2024 3.5508L16.4665 0.352088C18.5376 -0.907836 20.9078 1.46243 19.6479 3.53354L16.4492 8.79761C16.0005 9.534 16.0005 10.4602 16.4492 11.2024L19.6479 16.4665C20.9078 18.5376 18.5376 20.9078 16.4665 19.6479L11.2024 16.4492C10.466 16.0005 9.53975 16.0005 8.79761 16.4492L3.53354 19.6479C1.46243 20.9078 -0.907836 18.5376 0.352088 16.4665L3.5508 11.2024C3.99954 10.466 3.99954 9.53975 3.5508 8.79761L0.352088 3.53354C-0.907836 1.46243 1.46243 -0.907836 3.53354 0.352088L8.79761 3.5508C9.534 3.99954 10.4602 3.99954 11.2024 3.5508Z",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEtcIcon);
export default __webpack_public_path__ + "static/media/whiteEtcIcon.75196ea10908904aa21c518ca81493ba.svg";
export { ForwardRef as ReactComponent };